<template>
    <v-form ref="form_referencia_comercial">
        <v-container fluid grid-list-md v-show="_.size(listGeneral.cabeceraReferenciaComercial) > 0">
            <v-row dense>
                <v-col xs="12" sm="12">
                    <v-dialog v-model="abrirModal" :max-width="tamModal" :fullscreen="$root.isTouch"
                        :scrollable="$root.isTouch == false" persistent>
                        <template v-slot:activator="{ on }">
                            <div class="text-right">
                                <v-btn rounded dark color="primary" v-on="on">Nuevo</v-btn>
                            </div>
                        </template>
                        <v-card>
                            <v-card-title class="bg-title-card">
                                <span class="white--text headline" v-html="titulo"></span>
                            </v-card-title>
                            <v-container fluid grid-list-md>
                                <v-form ref="form_modal_referencia_comercial">
                                    <v-row dense>
                                        <v-col xs="12" sm="6">
                                            <v-text-field label="Institución *" color="textbox"
                                                v-model="objeto.institucion"
                                                :rules="_.concat(requeridoRegla,soloLetrasRegla(1,objeto.institucion,300))"
                                                outlined dense></v-text-field>
                                        </v-col>
                                        <v-col xs="12" sm="6">
                                            <v-text-field label="Producto *" color="textbox" v-model="objeto.producto"
                                                :rules="_.concat(requeridoRegla,soloLetrasRegla(1,objeto.producto,300))"
                                                outlined dense></v-text-field>
                                        </v-col>
                                    </v-row>
                                    <v-row dense>
                                        <v-col xs="12" sm="6">
                                            <v-text-field label="Teléfono Domicilio " color="textbox"
                                                v-model="objeto.telefono" v-mask="maskCelular"
                                                :rules="_.size(objeto.telefono) > 0 ? soloNumerosRegla(9,objeto.telefono,9) : []"
                                                outlined dense />
                                        </v-col>
                                    </v-row>
                                    <v-row dense>
                                        <v-col cols="12" class="text-right mt-3 mb-3">
                                            <v-btn outlined dense rounded color="danger" class="mr-1" @click="reset">
                                                Cancelar</v-btn>
                                            <v-btn rounded dark color="primary" @click="validarModal">Guardar</v-btn>
                                        </v-col>
                                    </v-row>
                                </v-form>
                            </v-container>
                        </v-card>
                    </v-dialog>
                </v-col>
            </v-row>
            <v-row dense>
                <v-col xs="12" sm="6" />
                <v-col xs="12" sm="6">
                    <v-text-field label="Buscar" color="textbox" v-model="objeto.busqueda" dense
                        prepend-inner-icon="search">
                    </v-text-field>
                </v-col>
            </v-row>
            <v-row dense>
                <v-col xs="12" sm="12">
                    <v-data-table :search="objeto.busqueda" :headers="listGeneral.cabeceraReferenciaComercial"
                        :items="listGeneral.listaReferenciaComercial" class="elevation-3">

                        <template v-slot:item.name="{ item }">
                            <v-btn class="ma-2" text icon color="primary" @click="onEditar(item)">
                                <v-icon small>edit</v-icon>
                            </v-btn>
                        </template>

                        <template v-slot:no-results>
                            Tu búsqueda de "<span v-text="objeto.busqueda"></span>" no arrojó resultados.
                        </template>
                    </v-data-table>
                </v-col>
            </v-row>
            <v-row dense>
                <v-col cols="12" class="text-right mt-3 mb-3">
                    <v-btn outlined dense rounded color="danger" class="mr-1" @click="previous('objRefCom',this.objForm)">Anterior</v-btn>
                    <v-btn rounded dark color="primary" @click="validar">Siguiente</v-btn>
                </v-col>
            </v-row>
        </v-container>
    </v-form>
</template>

<script>
    import { mask } from 'vue-the-mask';
    export default {
        name: 'StepperReferenciaComercialComponent',
        inject: ['previous', 'next'],
        directives:{ mask },
        props: {
            cargar: {
                type: Boolean,
                default: false
            },
            objForm: {
                type: Object,
                default: {}
            },
            listGeneral: {
                type: Object,
                default: {}
            },
        },
        data: () => ({
            abrirModal: false,
            titulo: 'Nueva Referencia Comercial',
            objeto: {},
            autorizacion: false,
            maskCelular: "##########",
        }),
        watch: {
            cargar(val) {
                if (val && _.size(this.listGeneral.listaReferenciaComercial) == 0) {
                    this.objeto = _.clone(this.objForm);

                    this.onListarCabecera()
                        .then((r) => {
                            if (_.size(_.get(r,['data','data'],[])) > 0) 
                                this.onListarDetalle();
                        });
                }
            }
        },
        methods: {
            onListarCabecera() {
                this.listGeneral.cabeceraReferenciaComercial = [];
                var objeto = { opcion: 'CAB_REFERENCIA_COMERCIAL' };
                var error = 'E';

                return axios.post(`${BASE_URI}administrador/prevension-lavado-activo/cliente/listar`,objeto)
                            .then((r) => {
                                if (_.get(r,['data','existeError'],true)) throw mensajeEstandar.errorPeticion;
                                if (_.size(_.get(r,['data','data'],[])) == 0) { error = 'I'; throw _.get(r,['data','mensaje'],mensajeEstandar.errorPeticion); }                                
                                    this.$set(this.listGeneral, 'cabeceraReferenciaComercial', r.data.data);
                                return r;
                            })
                            .catch((e)=>{
                                mensajesAlerta(e, error);
                                return e;
                            });
            },
            onListarDetalle() {
                var objeto = {
                    opcion: 'LISTAR_REFERENCIA_COMERCIAL',
                    idFormulario: _.get(this.objeto, 'idFormulario', null),
                    idCliente: _.get(this.objeto, 'idCliente', null),
                    idContratante: _.get(this.objeto, 'idContratante', null)
                };
                var error = 'E';
                this.listGeneral.listaReferenciaComercial = [];
                
                return axios.post(`${BASE_URI}administrador/prevension-lavado-activo/cliente/listar`,objeto)
                            .then((r) => {
                                if (_.get(r,['data','existeError'],true)) throw mensajeEstandar.errorPeticion;
                                if (_.size(_.get(r,['data','data'],[])) == 0) { error = 'I'; throw _.get(r,['data','mensaje'],mensajeEstandar.errorPeticion); }  
                                    var l = _.map(r.data.data, (v) => {
                                                v.id    = _.uniqueId();
                                                v.index = _.toString(v.index);
                                                return v;
                                            });       

                                    this.$set(this.listGeneral, 'listaReferenciaComercial',l);
                                return r;
                            })
                            .catch((e)=>{
                                mensajesAlerta(e, error);
                                return e;
                            });
            },
            validar() {
                try {
                    if (_.size(this.listGeneral.listaReferenciaComercial) == 0) throw mensajeEstandar.corregirInformacion;
                        this.next('objRefCom',this.objForm);
                } catch (e) {
                    mensajesAlerta(e,'I');
                }
            },
            onEditar(obj, index) {
                this.objeto = _.merge(this.objeto, obj);
                this.titulo = 'Editar Referencia Comercial';
                this.abrirModal = !this.abrirModal;
            },
            validarModal() {
                if (this.$refs.form_modal_referencia_comercial.validate()) {
                    var l = _.cloneDeep(this.listGeneral.listaReferenciaComercial);

                    if (_.size(this.objeto.id) == 0)
                        l.push(_.merge(this.objeto, { 'id': _.uniqueId() }));
                    else {
                        var pos = _.findIndex(l,{'id':this.objeto.id} );
                        l[pos] = _.merge(l[pos], this.objeto);
                    }

                    this.next('listaReferenciaComercial',l,false);
                    this.reset();
                }
            },
            reset() {
                this.abrirModal = !this.abrirModal;
                this.$refs.form_modal_referencia_comercial.resetValidation();
                this.objeto = _.clone(this.objForm);
                this.titulo = 'Nueva Referencia Comercial';
            }
        }
    }
</script>